import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import { millisecondsToTimestamp } from '../../util/TimeUtil';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const AboutDialog = ({ onClose }) => {

    const [version, setVersion] = useState(null);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        const response = await axios.get("/version");
        setVersion(response.data);
    };

    return (
        <Dialog
            open={version !== null}
            onClose={onClose}
            maxWidth='md'
            PaperComponent={PaperComponent}
        >
            <DialogTitle id="dialog-title" sx={{ cursor: 'move' }}>About</DialogTitle>
            <DialogContent>
                <Typography gutterBottom>{`Version: ${version?.versionString || 'Loading...'}`}</Typography>
                <Typography gutterBottom>{`Build Time: ${millisecondsToTimestamp(version?.buildTime) || 'Loading...'}`}</Typography>
                {version?.nonProduction &&
                    <Typography gutterBottom>Non-production environment</Typography>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AboutDialog;
